(function () {
  const isMobile = window.innerWidth < 767;
  if (isMobile) {
    window.setPreload = function () {
      console.log('Mobile detected - skipping MMQ preload handling');
    }

    let $activeMonitorHolder = null;

    $(".addOneMainInput__js").change(async function () {
      const root = $(this).closest(".product-single__add-one");

      // Monitor-holder mutual exclusion (mobile)
      const $monitorGroup = root.closest('.pdp_monitor-holder-addons-flex');
      if ($monitorGroup.length > 0) {
        const isNowChecked = $(this).is(':checked');
        if (isNowChecked) {
          const $prev = $activeMonitorHolder;
          $activeMonitorHolder = root;
          if ($prev && $prev.length) {
            $prev.find('.addOneMainInput__js').prop('checked', false);
          }
        } else {
          $activeMonitorHolder = null;
        }
      }

      var clickedAddon = $(this).closest(".product-single__add-one");

        if (clickedAddon.hasClass("add-one-crossell__main")) {
          
          var slideIndex = parseInt(clickedAddon.closest('.add-one-crossell').data("index"), 10) - 1;
        
          console.log("Scrolling to slide:", slideIndex);
          const $slides = $('.addone-second-swiper .swiper-slide');
          const $target = $slides.eq(slideIndex);
        
          if ($target.length) {
            const container = $('.addone-second-swiper');
            const scrollLeft = container.scrollLeft();
            const slideLeft = $target.position().left + scrollLeft;
            const OFFSET = 60;
        
            let targetOffset = slideLeft - OFFSET;
            if (targetOffset < 0) targetOffset = 0;
        
            container.animate({ scrollLeft: targetOffset }, 300);
          }
        }


      // MOBILE CROSS-SELL LOGIC
        if (root.hasClass("add-one-crossell__main")) {
          $(".add-one-crossell__main").removeClass("clickedNow");
          root.addClass("clickedNow");
          
          $(".add-one-crossell__main").each(function () {
            if ($(this).hasClass("clickedNow")) {
              console.log("Found class");
            } else {
              $(this)
                .closest(".add-one-crossell")
                .find(".addOneMainInput__js")
                .each(function () {
                  $(this).prop("checked", false);
                });
            }
          });
        }
        
        if (root.hasClass("add-one-crossell__main")) {
          var isChildAddonSelected = $(".add-one-crossell__secondary")
            .find(".addOneMainInput__js")
            .is(":checked");
          if (isChildAddonSelected) {
            var currentAddonsQnt = $(".js-add-to-cart").attr("data-qnt");
            currentAddonsQntNew = currentAddonsQnt - 1;
            $(".add-one-crossell__secondary").trigger("click");
          }
        }
      // SECONDARY ADDON CLEANUP WITH PROPER TIMING (1500ms)
      setTimeout(() => {
        let activeAddons = 0;
        
        $(".add-one-crossell__main").each(function () {
          $(this)
            .find(".addOneMainInput__js:checked")
            .each(function () {
              activeAddons++;
            });
        });

        if (activeAddons === 0) {
          $(".add-one-crossell__secondary")
            .find(".addOneMainInput__js:checked")
            .each(function () {
              $(this).closest(".add-one-crossell__secondary").trigger("click");
            });
        }
      }, 1500);
    });
  }
  else{
    // ---------------------------------------------------------------------------
    // GLOBAL STATE
    // ---------------------------------------------------------------------------
    window.mmqFirstStateLoaded = false;
    window.mmqFirstStateLoadingIs = true;
    window.mmqLoaded = false;
    window.mmqScriptLoaded = false;
    window.mmqTriggered = false;
    window.mmQisLoading = false;
    window.mmqShowed = false;

    // Tracks the currently selected monitor-holder <li> for remove-then-add 3D sequencing
    let $activeMonitorHolder = null;

    let mmqLoadedDetectedAt = false;

    // ---------------------------------------------------------------------------
    // HELPERS
    // ---------------------------------------------------------------------------

    function retriggerLoadEvent(){
      setInterval(()=>{
        if (!!window.mimeeqApp && !window.mmqScriptLoaded) {
          // retrigger event for loaded in case script loaded after embed script was loaded
          document.dispatchEvent(new Event('mimeeq-app-loaded'));
        }
      },1000)
    
    }

    /** Poll helper */
    function pollUntil(fn, interval = 20, attempts = 20000) {
      return new Promise((resolve, reject) => {
        let counter = 0;

        const check = () => {
          try {
            if (fn()) return resolve(true);
          } catch (e) {
            return reject(e);
          }

          counter++;
          if (counter >= attempts) {
            return reject(new Error("Polling timeout"));
          }

          setTimeout(check, interval);
        };

        check();
      });
    }

    /** Wait for 3D render */
    function waitFor3dLoaded() {
      return new Promise((resolve, reject) => {
        let resolved = false;

        const onEvent = () => {
          if (resolved) return;
          resolved = true;
          clearInterval(intervalId);
          document.removeEventListener("mimeeq-3d-product-initialized", onEvent);
          resolve(true);
        };

        document.addEventListener("mimeeq-3d-product-initialized", onEvent, {
          once: true,
        });

        let checks = 0;
        const intervalId = setInterval(() => {
          checks++;
          if (window.mimeeq3dLoaded) onEvent();
          if (checks > 20000) {
            clearInterval(intervalId);
            document.removeEventListener("mimeeq-3d-product-initialized", onEvent);
            reject(new Error("3D Loaded timeout"));
          }
        }, 20);
      });
    }

    // Cache selectors
    const $productBox = $(".product_selection-all-box");
    const $opener3D = $(".opener-3D");

    const waitFor = (condition, interval = 200) =>
      new Promise((resolve) => {
        const i = setInterval(() => {
          if (condition()) {
            clearInterval(i);
            resolve(true);
          }
        }, interval);
      });

    const getConfigData = () => {
      const currentId = $(".pp_config__main_id-js").attr("data-id");
      const $cfg = $(`.pp_variant_config[data-id="${currentId}"]`);
      return {
        configString: $cfg.attr("data-mmq-initial-load-string"),
        configTitle: $cfg.attr("data-title"),
      };
    };

    // ---------------------------------------------------------------------------
    // MMQ CONFIGURATOR READINESS STATE MACHINE
    // ---------------------------------------------------------------------------
    window.__mmqEnsureReadyPromise = window.__mmqEnsureReadyPromise || null;
    window.__mmqConfiguratorAlreadyReady =
      window.__mmqConfiguratorAlreadyReady || false;

    function ensureConfiguratorReady() {


      if (window.__mmqConfiguratorAlreadyReady) {
        return Promise.resolve(true);
      }

      if (window.__mmqEnsureReadyPromise) {
        return window.__mmqEnsureReadyPromise;
      }

      window.__mmqEnsureReadyPromise = new Promise(async (resolve, reject) => {
        try {
          // 1) Wait for app loaded
          await pollUntil(() => !!window.mimeeqAppLoaded, 20, 20000);

          // 2) Find embed
          const embed =
            document.querySelector("mmq-embed") ||
            document.querySelector(".mmq-embed");

          if (!embed) return reject(new Error("mmq-embed element missing"));

          if (typeof embed.show === "function") embed.show();

          // 3) Wait for 3D ready
          await waitFor3dLoaded();

          window.__mmqConfiguratorAlreadyReady = true;
          resolve(true);
        } catch (e) {
          reject(e);
        }
      });

      return window.__mmqEnsureReadyPromise;
    }

    // ---------------------------------------------------------------------------
    // PRELOAD HANDLING
    // ---------------------------------------------------------------------------
    window.removePreloads = function () {
      setTimeout(function(){
        $productBox.removeClass("preload");
        $opener3D.removeClass("preloading");
        $('.product-single__add-to-cart').removeClass('preloadActive');
        $(".product-single").addClass("loadedVar");
        window.hideSkeleton();
      },1000);
    };

    function runPreloadHiding(){
      $('.pp_media-3d-enable-na').hide();
      $('.main_gallery_3d_laoder').addClass('activated3d');
      $('.main_gallery_3d_laoder').css('opacity', '0');
      $('.loader__boxing_loader-outer-3step').show();
      $('.product__media-zoomin-btns').addClass('activated');
      setTimeout(function(){
        $('.main_gallery_3d_laoder').hide();
        $('.product__media-wrapper').removeClass('preloading3d');
        $('.product_selection-all-box').removeClass('Not3dEnabled');
      },500);

      setTimeout(function(){
        $('.loader__boxing_loader-outer-3step').hide();
      },3000);
    }

    window.setPreload = function () {
      if (window.preselectingBundles == true) {
        return;
      }

      window.mmqTriggered = true;
      if (mmqLoadedDetectedAt){
        if (!window.mmqLoaded) $opener3D.addClass("preloading");
        $productBox.addClass("preload");

        console.log("Preload added to addons wrap");

        // Keep the visual timeout — UX only
        setTimeout(() => {
          if ($productBox.hasClass("preload")) {
            console.log("Preload still present after fallback timeout");
            $productBox.removeClass("preload");
          }
        }, 9500);
      }
      else{
        $('.product__media-wrapper').addClass('preloading3d');
        $productBox.addClass("preload");
        $('.pp_media-3d-enable-nav').hide();

        setTimeout(() => {
          if ($('.product__media-wrapper').hasClass("preloading3d")) {
            console.log("Preload still present after fallback timeout");
            $('.product__media-wrapper').removeClass('preloading3d');
            $productBox.removeClass("preload");
            $('.product_selection-all-box').removeClass('Not3dEnabled');
          }
        }, 9500);
      }
    };

    // ---------------------------------------------------------------------------
    // LOAD CONFIGURATOR SEQUENCE
    // ---------------------------------------------------------------------------
    async function loadConfiguratorSequence() {
      const { configString, configTitle } = getConfigData();

      await ensureConfiguratorReady();

      // Apply configuration
      // await window.mimeeqApp.actions.setConfigurationCode(configString);
      await Promise.race([
        window.mimeeqApp.actions.setConfigurationCode(configString),
        new Promise((resolve) => {
          console.warn("Safari fallback → forcing configuration apply after 4s");
          setTimeout(resolve, 4000);
        }),
      ]);

      await new Promise(res=>setTimeout(res,3000))

      console.log(
        `%cMMQ ${configTitle} FIRST CONFIGURATOR LOADED`,
        "background: orange; color: white; padding: 6px; border-radius: 4px;"
      );

      window.mmqFirstStateLoadingIs = false;
      window.mmqFirstStateLoaded = true;

      // Mark ready immediately (no artificial wait)
      window.mmqLoaded = true;
      mmqLoadedDetectedAt = true;

      console.log(
        "%cMMQ WINDOW.MMQLOADED TRUE",
        "background: #00b894; color: white; padding: 6px; border-radius: 4px;"
      );

      $('.product-3d-window').addClass('open');

      runPreloadHiding();

      // Remove preload immediately — unless UX requires delay
      window.removePreloads();
    }

    // ---------------------------------------------------------------------------
    // PUBLIC: window.renderConfiguratorCode()
    // ---------------------------------------------------------------------------
    window.renderConfiguratorCode = async function () {
      if (!window.mmqScriptLoaded) {
        console.log("Waiting for MMQ script...");
        await waitFor(() => window.mmqScriptLoaded, 200);
      }

      await ensureConfiguratorReady();
      await loadConfiguratorSequence();
    };

    // ---------------------------------------------------------------------------
    // EVENT: SCRIPT LOADED
    // ---------------------------------------------------------------------------
    document.addEventListener("mimeeq-app-loaded", () => {
      window.mmqScriptLoaded = true;
    });

    // ---------------------------------------------------------------------------
    // DOM READY
    // ---------------------------------------------------------------------------
    document.addEventListener("DOMContentLoaded", () => {
      const configurator3D = document.getElementById("gallery-3d-window");
      const mimeeqOpener = document.querySelector("[is-3d-opener]");

      retriggerLoadEvent();

      function stopVideos() {
        window.pdpSwiper?.slideTo(0);
        $(".product-single__media video").each(function () {
          this.pause();
          this.currentTime = 0;
        });
      }

      // -------------------------------------------------------------------------
      // OPEN 3D CONFIGURATOR
      // -------------------------------------------------------------------------
      mimeeqOpener.addEventListener("click", async () => {
        stopVideos();

        if (window.mmqShowed) {
          configurator3D.classList.add("open");
          $('.product__media-zoomin-btns').addClass('activated');
          return;
        }

        window.setPreload();

        $(".desktronic_loader3d_out").addClass("active");
        $(".loader.desktronic_loader_2step").show();

        await ensureConfiguratorReady();
        await ensureMMQLoaded();

        configurator3D.classList.add("open");
        $('.product__media-zoomin-btns').addClass('activated');
        $(".desktronic_loader3d_out").addClass("active2nd");
        $(".loader.desktronic_loader_2step").hide();
        $(".loader.desktronic_loader_3step").show();

        // Pure UI timing — keep
        setTimeout(() => {
          $(".loader.desktronic_loader_3step").hide();
          $(".desktronic_loader3d_out").removeClass("active2nd active");
        }, 3500);

        window.mmqShowed = true;
      });

      // -------------------------------------------------------------------------
      // ADDONS CORE LOGIC
      // -------------------------------------------------------------------------
      async function toggleAddon({ clicked, hasMulti, isChecked }) {
        $('.product__media-zoomin-btn').removeClass('active');
        const addonFullTitle = clicked
          .find(".product__additional-variant input:checked")
          .attr("value");

        const $cfg = $(`.mmqMonitorArmConfig[data-title="${addonFullTitle}"]`);

        const addonCode = hasMulti
          ? $cfg.attr("data-mmq-code")
          : clicked.find(".addOneMainInput__js").attr("data-mmq-code");

        const addonBlock = hasMulti
          ? $cfg.attr("data-mmq-block")
          : clicked.find(".addOneMainInput__js").attr("data-mmq-block");

        const addonHide = clicked
          .find(".addOneMainInput__js")
          .attr("data-mmq-hide-code");

        await window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
          addonBlock,
          isChecked ? addonCode : addonHide
        );
      }


      async function ensureMMQLoaded() {
        if (!window.mmqLoaded) {
          await window.renderConfiguratorCode();
          await waitFor(() => window.mmqLoaded, 200);
        }
      }

      // -------------------------------------------------------------------------
      // DESKTOP CROSS-SELL CONFLICT RESOLUTION
      // -------------------------------------------------------------------------
      $(".add-one-crossell .addOneMainInput__js").change(function () {
        if ($(window).width() > 767) {
          if (
            !$(this)
              .closest(".product-single__add-one")
              .hasClass("add-one-crossell__secondary")
          ) {
            var clickedAddon = $(this).closest(".product-single__add-one");
            var selectedCrosses = 0;

            $(".product-single__add-one.crossell.add-one-crossell__main").each(
              function () {
                if (!$(this).is(clickedAddon)) {
                  if ($(this).find(".addOneMainInput__js").is(":checked")) {
                    selectedCrosses++;
                    $(this).find(".addOneMainInput__js").prop("checked", false);

                    if (
                      $(this)
                        .closest(".add-one-crossell")
                        .find(".add-one-crossell__secondary .addOneMainInput__js")
                        .is(":checked")
                    ) {
                      const that = this;

                      setTimeout(async function () {
                        $(that)
                          .closest(".add-one-crossell")
                          .find(".add-one-crossell__secondary")
                          .trigger("click");
                      }, 2000);
                    }
                  }
                }
              }
            );
          }
        }
      });

      // -------------------------------------------------------------------------
      // VARIANT CLICK
      // -------------------------------------------------------------------------
      $(".add-one__variants").click(async function (evt) {

      

        if (
          $(evt.target).closest(".add-one__item-slider-prev, .add-one__item-slider-next").length
        ) {
          return;
        }

        const root = $(this).closest(".product-single__add-one");
        if (!root.find(".addOneMainInput__js").is(":checked")) return;

        if (window.mmqLoaded == false) {
          window.renderConfiguratorCode();
        }

        const mmqInterval = setInterval(async () => {
          if (window.mmqLoaded) {
            clearInterval(mmqInterval);

            const hasMulti = root.hasClass("hasMultiOptions");
            if (window.mmQisLoading) return;

            window.mmQisLoading = true;
            setTimeout(() => (window.mmQisLoading = false), 1000);

            if (!hasMulti) {
              const $sel = root.find(".product__additional-variant input:checked");
              if ($sel.length) {
                root.find(".addOneMainInput__js")
                  .attr("data-mmq-code", $sel.attr("data-mmq-code"))
                  .attr("data-mmq-block", $sel.attr("data-mmq-block"))
                  .attr("data-id", $sel.attr("data-id"));
              }
            }

            toggleAddon({
              clicked: root,
              hasMulti,
              isChecked: root.find(".addOneMainInput__js").is(":checked"),
            });

            console.log('Addone variants clicked', hasMulti, 'TESTING');

            window.mmqShowed = true;
          }
        }, 200);
      });

      // -------------------------------------------------------------------------
      // NAVIGATION FOR ZOOMINS
      // -------------------------------------------------------------------------

      $('.product__media-zoomin-btn').click(function(){
        $('.product__media-zoomin-btn').addClass('loading');
        setTimeout(function(){
          $('.product__media-zoomin-btn').removeClass('loading');
        },1000);
        if ($(this).hasClass('active')){
          $('.product__media-zoomin-btn').removeClass('active');

          const mmqInterval = setInterval(async () => {
            if (window.mmqLoaded) {
              clearInterval(mmqInterval);

              if (window.mmQisLoading) return;
              window.mmQisLoading = true;
              setTimeout(() => (window.mmQisLoading = false), 1000);
              var addonBlock = $(this).attr('data-addon-block');
              var addonCode = $(this).attr('data-addon-revert-code');
              window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
                addonBlock,
                addonCode
              );
              window.mmqShowed = true;
            }
          }, 200);
        }
        else{
          $('.product__media-zoomin-btn').removeClass('active');
          $(this).addClass('active');

          $('.opener-3D').trigger('click');

          const mmqInterval = setInterval(async () => {
            if (window.mmqLoaded) {
              clearInterval(mmqInterval);

              if (window.mmQisLoading) return;
              window.mmQisLoading = true;
              setTimeout(() => (window.mmQisLoading = false), 1000);
              var addonBlock = $(this).attr('data-addon-block');
              var addonCode = $(this).attr('data-addon-code');
              window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
                addonBlock,
                addonCode
              );
              window.mmqShowed = true;
            }
          }, 200);
        }
        
      });

      // -------------------------------------------------------------------------
      // MAIN CHECKBOX CHANGE
      // -------------------------------------------------------------------------
      $(".addOneMainInput__js").change(async function () {
        const root = $(this).closest(".product-single__add-one");

        // Monitor-holder: capture previous selection before any DOM changes, then apply mutual exclusion
        const $monitorGroup = root.closest('.pdp_monitor-holder-addons-flex');
        const isMonitorHolder = $monitorGroup.length > 0;
        const isNowChecked = $(this).is(':checked');
        let $prevMonitorLi = null;

        if (isMonitorHolder) {
          if (isNowChecked) {
            $prevMonitorLi = $activeMonitorHolder;
            $activeMonitorHolder = root;
            // Uncheck the sibling without triggering its change event
            if ($prevMonitorLi && $prevMonitorLi.length) {
              $prevMonitorLi.find('.addOneMainInput__js').prop('checked', false);
            }
          } else {
            $activeMonitorHolder = null;
          }
        }

        if (window.mmqLoaded == false) {
          window.renderConfiguratorCode();
        }

        var clickedAddon = $(this).closest(".product-single__add-one");

        if (clickedAddon.hasClass("add-one-crossell__main")) {
          
          var slideIndex = parseInt(clickedAddon.closest('.add-one-crossell').data("index"), 10) - 1;
        
          console.log("Scrolling to slide:", slideIndex);
          const $slides = $('.addone-second-swiper .swiper-slide');
          const $target = $slides.eq(slideIndex);
        
          if ($target.length) {
            const container = $('.addone-second-swiper');
            const scrollLeft = container.scrollLeft();
            const slideLeft = $target.position().left + scrollLeft;
            const OFFSET = 60;
        
            let targetOffset = slideLeft - OFFSET;
            if (targetOffset < 0) targetOffset = 0;
        
            container.animate({ scrollLeft: targetOffset }, 300);
          }
        }
        


        // MOBILE CROSS-SELL LOGIC
        if ($(window).width() < 767) {
          if (root.hasClass("add-one-crossell__main")) {
            $(".add-one-crossell__main").removeClass("clickedNow");
            root.addClass("clickedNow");
            
            $(".add-one-crossell__main").each(function () {
              if ($(this).hasClass("clickedNow")) {
                console.log("Found class");
              } else {
                $(this)
                  .closest(".add-one-crossell")
                  .find(".addOneMainInput__js")
                  .each(function () {
                    $(this).prop("checked", false);
                  });
              }
            });
          }
          
          if (root.hasClass("add-one-crossell__main")) {
            var isChildAddonSelected = $(".add-one-crossell__secondary")
              .find(".addOneMainInput__js")
              .is(":checked");
            if (isChildAddonSelected) {
              var currentAddonsQnt = $(".js-add-to-cart").attr("data-qnt");
              currentAddonsQntNew = currentAddonsQnt - 1;
              $(".add-one-crossell__secondary").trigger("click");
            }
          }
        } 
        // DESKTOP LOGIC - WRAPPED IN MMQ CHECK
        else {
          const mmqInterval = setInterval(async () => {
            if (window.mmqLoaded) {
              clearInterval(mmqInterval);

              if (window.mmQisLoading) return;

              window.mmQisLoading = true;
              setTimeout(() => (window.mmQisLoading = false), 1000);

              // Monitor-holder: remove old from 3D then immediately add new (await ensures sequencing)
              if (isMonitorHolder && isNowChecked && $prevMonitorLi && $prevMonitorLi.length) {
                await toggleAddon({
                  clicked: $prevMonitorLi,
                  hasMulti: $prevMonitorLi.hasClass("hasMultiOptions"),
                  isChecked: false,
                });
                toggleAddon({
                  clicked: root,
                  hasMulti: root.hasClass("hasMultiOptions"),
                  isChecked: true,
                });
              } else {
                const hasMulti = root.hasClass("hasMultiOptions");
                if (!hasMulti) {
                  const $sel = root.find(".product__additional-variant input:checked");
                  if ($sel.length) {
                    root.find(".addOneMainInput__js")
                      .attr("data-mmq-code", $sel.attr("data-mmq-code"))
                      .attr("data-mmq-block", $sel.attr("data-mmq-block"))
                      .attr("data-id", $sel.attr("data-id"));
                  }
                }
                toggleAddon({
                  clicked: root,
                  hasMulti,
                  isChecked: root.find(".addOneMainInput__js").is(":checked"),
                });
              }

              window.mmqShowed = true;
            }
          }, 200);
        }

        // SECONDARY ADDON CLEANUP WITH PROPER TIMING (1500ms)
        setTimeout(() => {
          let activeAddons = 0;
          
          $(".add-one-crossell__main").each(function () {
            $(this)
              .find(".addOneMainInput__js:checked")
              .each(function () {
                activeAddons++;
              });
          });

          if (activeAddons === 0) {
            $(".add-one-crossell__secondary")
              .find(".addOneMainInput__js:checked")
              .each(function () {
                $(this).closest(".add-one-crossell__secondary").trigger("click");
              });
          }
        }, 1500);
      });

      $(document).on("click", ".product-single__media-group-wrapper", function () {
        $('.loader__boxing_loader-outer-3step').hide();
      });
    });
  }

})();